export function normalizeTricklistEntries(tricks = []) {
  return (Array.isArray(tricks) ? tricks : []).map((trick) => {
    const normalized = { ...trick };
    const value = parseFloat(normalized.value);
    normalized.value = Number.isNaN(value) ? 0 : value;

    const score = parseFloat(normalized.score);
    normalized.score = Number.isNaN(score) ? 0 : score;

    return normalized;
  });
}

export function buildTricklistCacheKey(versionId) {
  return versionId ? `tricks:${versionId}` : 'tricks:default';
}

export function readCachedTricklist(secureStorage, versionId) {
  const scoped = parseJson(secureStorage.getItem(buildTricklistCacheKey(versionId)));
  if (Array.isArray(scoped) && scoped.length) {
    return scoped;
  }

  const legacy = parseJson(secureStorage.getItem('tricks'));
  return Array.isArray(legacy) ? legacy : [];
}

export function writeCachedTricklist(secureStorage, versionId, tricks) {
  const serialized = JSON.stringify(tricks || []);
  secureStorage.setItem(buildTricklistCacheKey(versionId), serialized);
  secureStorage.setItem('tricks', serialized);
}

function parseJson(value) {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}